export default {"src":"https://dap-o2cg76iga-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};